export const TODAY_NEWS = 'today_news'
